import { Link } from "react-router-dom";
import { useLang } from "@/i18n";
import { scrollToId } from "@/components/Navbar";

export default function Footer() {
  const { t } = useLang();
  return (
    <footer className="relative bg-[#0A0F20] border-t hairline overflow-hidden" data-testid="footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-20 pb-10">
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-12">
          <div>
            <span className="inline-flex items-center justify-center rounded-2xl bg-gradient-to-br from-white via-[#F7F2E7] to-[#EDE4CF] px-5 py-3 ring-1 ring-gold/50 shadow-[0_0_44px_rgba(212,175,55,0.3)] mb-8">
              <img src="/assets/logo-emblem.png" alt="Bridge Intell" className="h-20 w-auto" data-testid="footer-logo" />
            </span>
            <p className="font-serif text-3xl sm:text-4xl lg:text-5xl font-medium leading-tight text-slate-100 max-w-xl" data-testid="footer-signature">
              <span className="italic gold-text">{t.footer.signature}</span>
            </p>
            <p className="mt-6 text-sm text-slate-400 font-light">{t.footer.alt1}</p>
            <p className="mt-1 text-sm text-slate-400 font-light">{t.footer.alt2}</p>
          </div>
          <nav className="grid grid-cols-2 gap-x-16 gap-y-3 text-sm">
            {[["bridge", t.nav.bridge], ["directions", t.nav.directions], ["method", t.nav.method], ["sectors", t.nav.sectors], ["confidentiality", t.nav.confidentiality], ["opportunities", t.nav.opportunities], ["contact", t.nav.contact]].map(([id, label]) => (
              <button key={id} data-testid={`footer-link-${id}`} onClick={() => scrollToId(id)}
                className="text-left text-slate-400 hover:text-gold transition-colors duration-300 font-light">
                {label}
              </button>
            ))}
          </nav>
        </div>

        <div className="mt-16 pt-8 border-t border-slate-800/60 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
          <p className="text-[11px] font-mono uppercase tracking-[0.22em] text-slate-400">
            Bridge Intell — © {new Date().getFullYear()} {t.footer.rights}
          </p>
          <Link to="/admin/login" data-testid="footer-admin-link" className="text-[11px] font-mono uppercase tracking-[0.22em] text-slate-400 hover:text-gold transition-colors duration-300">
            {t.nav.admin}
          </Link>
        </div>
      </div>
    </footer>
  );
}
